import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName:"HeaderMobile" */ './HeaderMobile').then((mod) => mod.default));
